import Paragraph from "@tiptap/extension-paragraph";

// Paragraph node with support for inline style attributes (e.g., line-height)
const CustomParagraph = Paragraph.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute("style"),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return { style: attributes.style };
        },
      },
    };
  },
});

export default CustomParagraph;


